import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill="currentColor">
      <path d="M23 4.2a4.8 4.8 0 100 9.6 4.8 4.8 0 000-9.6zm0 1.6a3.2 3.2 0 110 6.4 3.2 3.2 0 010-6.4zM13 18.2a.8.8 0 01.794.7l.006.1v8a.8.8 0 01-1.594.1L12.2 27v-7.2H5a.8.8 0 01-.794-.7L4.2 19a.8.8 0 01.7-.794L5 18.2h8zM13.241 10.747a.8.8 0 011.545.4l-.027.106-1 3a.8.8 0 01-1.545-.4l.027-.106 1-3zM19.747 16.241a.8.8 0 01.607 1.477l-.101.04-3 1a.8.8 0 01-.607-1.476l.101-.04 3-1zM16.934 12.934a.8.8 0 011.21 1.042l-.078.09-2.5 2.5a.8.8 0 01-1.21-1.042l.078-.09 2.5-2.5z" />
    </g>
  </svg>
);

const IconWoodwork = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconWoodwork;
